import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';
import { MdClose } from 'react-icons/md';
import { listRevisions } from '~/api/titleOpinion';
import { Modal, Grid } from '~/components';

const headerClassName = 'bg-gray-50 p-2 border-b text-left';
const props = { className: 'p-2 text-sm border-b' };

const columns = [
    {
        title: 'Date',
        field: 'created',
        headerClassName,
        props: { 
            ...props,
            style: { whiteSpace: 'nowrap' }
        }
    },
    {
        title: 'Details',
        field: 'text',
        headerClassName,
        props
    },
    {
        title: 'Files',
        field: 'files',
        cell: ({ data }) => data.files.map(file => file.uploadInfo.fileName).join(', '),
        headerClassName,
        props
    }
];

const RevisionsModal = ({ isOpen, setIsOpen, activeTitleOpinionId }) => {
    const [revisions, setRevisions] = useState([]);

    useEffect(() => {
        const fetchRevisions = async () => {
            const data = await listRevisions(activeTitleOpinionId);
            const formattedData = data.map(item => {
                const details = JSON.parse(item.details);

                return {
                    ...item,
                    created: format(new Date(item.created), 'MM/dd/yyyy hh:mm aaa'),
                    text: details.revisions,
                    files: details.files
                };
            });
            setRevisions(formattedData);
        };

        if (isOpen && activeTitleOpinionId) {
            fetchRevisions();
        }
    }, [isOpen, activeTitleOpinionId]);

    return (
        <Modal isModalOpen={isOpen} preventScroll className='rounded-md bg-white w-3/4'>
            <section className='w-full h-full flex flex-col items-stretch justify-start'>
                <header className="border-b-2 text-sm flex items-center justify-between py-2 px-6">
                    <p className="font-semibold">Revisions</p>
                    <button className="py-2 rounded-full" onClick={() => setIsOpen(false)}>
                        <MdClose size="1em" />
                    </button>
                </header>
                <div className='flex flex-col items-center justify-center flex-1 p-6'>
                    <Grid
                        className='w-full text-sm text-neutral-90 mb-2'
                        columns={columns}
                        data={revisions}
                        usePagination={false}
                    />
                </div>
            </section>
        </Modal>
    );
};

export default RevisionsModal;